import { render } from "./NewsCreator.vue?vue&type=template&id=48c02d9c&scoped=true"
import script from "./NewsCreator.vue?vue&type=script&lang=js"
export * from "./NewsCreator.vue?vue&type=script&lang=js"

import "./NewsCreator.vue?vue&type=style&index=0&id=48c02d9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c02d9c"]])

export default __exports__